import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ConfigProvider } from "antd";
import { LanguageProvider, useTranslation } from "./i18n/LanguageContext";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Volunteers from "./Pages/Volunteers";
import Organizations from "./Pages/Organizations";
import Events from "./Pages/Events";
import EventDetail from "./Pages/EventDetail";
import BecomePartner from "./Pages/BecomePartner";
import TermsOfUse from "./Pages/TermsOfUse";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import VolunteerAgreement from "./Pages/VolunteerAgreement";
import Feedback from "./Pages/Feedback";
import RegisterOrganization from "./Pages/RegisterOrganization";
import MainLayout from "./MainLayout";
import AdminApp from "./admin/AdminApp";
import AppRedirect from "./Pages/AppRedirect";
import "./App.css";

const buildTheme = (lang) => ({
    token: {
        colorPrimary: "#ff7b00",
        colorInfo: "#0084ff",
        colorLink: "#0084ff",
        colorLinkHover: "#0070dd",
        borderRadius: 10,
        // Russian uses Montserrat (full Cyrillic weights); others Montserratarm.
        fontFamily:
            lang === "ru"
                ? "Montserrat, sans-serif"
                : "Montserratarm, sans-serif",
        fontSize: 16,
        controlHeightLG: 52,
        colorText: "#2f3742",
        colorTextHeading: "#14181f",
        colorBorder: "#e7eaee",
    },
    components: {
        Button: {
            primaryShadow: "0 8px 20px rgba(255, 123, 0, 0.28)",
            fontWeight: 600,
        },
        Collapse: {
            headerPadding: "18px 4px",
            contentPadding: "4px 4px 18px",
        },
    },
});

function ThemedApp() {
    const { lang } = useTranslation();
    return (
        <ConfigProvider theme={buildTheme(lang)}>
            <BrowserRouter>
                <Routes>
                    <Route element={<MainLayout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/About" element={<About />} />
                        <Route path="/Volunteers" element={<Volunteers />} />
                        <Route
                            path="/Organizations"
                            element={<Organizations />}
                        />
                        <Route path="/Events" element={<Events />} />
                        <Route path="/events/:id" element={<EventDetail />} />
                        <Route
                            path="/BecomePartner"
                            element={<BecomePartner />}
                        />
                        <Route path="/TermsOfUse" element={<TermsOfUse />} />
                        <Route
                            path="/PrivacyPolicy"
                            element={<PrivacyPolicy />}
                        />
                        <Route path="/Feedback" element={<Feedback />} />
                        <Route
                            path="/registerOrganization"
                            element={<RegisterOrganization />}
                        />
                        <Route
                            path="/VolunteerAgreement"
                            element={<VolunteerAgreement />}
                        />
                    </Route>
                    {/* Deep-link landing pages for shared app content. When the
                        app is installed the OS opens it directly (Universal/App
                        Links) and these never render; otherwise they bounce to
                        the app store. Kept outside MainLayout (no header/footer). */}
                    <Route path="/post/:id" element={<AppRedirect kind="post" />} />
                    <Route path="/event/:id" element={<AppRedirect kind="event" />} />
                    {/* Admin panel — fully isolated, no public links point here */}
                    <Route path="/admin/*" element={<AdminApp />} />
                </Routes>
            </BrowserRouter>
        </ConfigProvider>
    );
}

function App() {
    return (
        <LanguageProvider>
            <ThemedApp />
        </LanguageProvider>
    );
}

export default App;
